<template>
	<div id="introduce-business">
		<vue-waterfall-easy ref="waterfall" :maxCols="2" :imgsArr="imgsArr" @scrollReachBottom="getData" :isRouterLink="true" :mobileGap="14" :enablePullDownEvent="true">
			<div class="img-info" slot-scope="props">
				<div class="business-name">{{ props.value.data.name }}</div>
				<div class="business-type">{{ props.value.data.type }}</div>
			</div>
			<div class="finished-text" slot="waterfall-over">没有更多了</div>
		</vue-waterfall-easy>
	</div>
</template>

<script>
import vueWaterfallEasy from 'vue-waterfall-easy'
import { mapGetters } from 'vuex'

export default {
	name: 'app',
	data() {
		return {
			pageNo: 1,
			pageSize: 20,
			imgsArr: [],
			total: null,
		}
	},
	components: {
		vueWaterfallEasy,
	},
	mounted() {
		this.adaptHeight()
		this.getData()
	},
	computed: {
		...mapGetters(['token', 'userId', 'communityId']),
	},
	methods: {
		getData() {
			this.list = []
			// 数据全部加载完成
			if (this.total != null && this.imgsArr.length >= this.total) {
				this.$refs?.waterfall.waterfallOver()
				return
			}
			this.vaxios.get(
				this.vaxios.host + '/open/api/v1/merchants/community/' + this.$route.query.communityId,
				{
					pageNo: this.pageNo,
					pageSize: this.pageSize,
				},
				(res) => {
					if (res.data.total == null || res.data.total == 0) {
						this.$refs?.waterfall.waterfallOver()
						return
					}

					let item
					let array = res.data.list

					for (let i = 0; i < array.length; i++) {
						item = {
							src: array[i].thumbnail_url,
							href: `/introduce/business/detail?id=${array[i].id}&industryname=${encodeURIComponent(array[i].industry_name)}`,
							data: {
								name: array[i].merchant_name,
								type: array[i].industry_name,
							},
						}
						this.imgsArr.push(item)
					}
					this.pageNo++
					this.total = res.data.total
				},
				function(err) {
					console.log(err)
					this.$refs?.waterfall.waterfallOver()
				}
			)
		},

		adaptHeight() {
			let deviceHeight = document.body.offsetHeight
			document.getElementById('introduce-business').style.height = deviceHeight - 44 + 'px'
		},
	}
}
</script>

<style>
.img-wraper,
.img-wraper > img {
	border-top-left-radius: 0.4375rem;
	border-top-right-radius: 0.4375rem;
}

/*#introduce-business{*/
/*background-color: red;*/
/*}*/
.img-inner-box {
	border-bottom-left-radius: 0.4375rem;
	border-bottom-right-radius: 0.4375rem;
	box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.04) !important;
	padding-bottom: 0.75rem;
}

.finished-text {
	color: #969799;
	font-size: 14px;
	line-height: 50px;
	text-align: center;
}

.business-name {
	font-weight: bold;
	font-size: 0.875rem;
	color: #272727;
	margin-left: 0.78125rem;
	margin-top: 0.8125rem;
}

.business-type {
	text-align: right;
	font-size: 0.75rem;
	color: #5c5c5c;
	margin-right: 0.75rem;
}
</style>
